import * as React from 'react';
import { 
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  TextField,
  Select,
  Popover
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { transform } from 'lodash';

const CDialog = styled(Dialog)({
  '>.MuiPaper-root': {
    borderRadius: 0
  }
})

const CDialogTitle = styled(DialogTitle)({
  background: '#fafafa',
  fontSize: '1rem',
  padding: '0.75rem',
  color: '#424242',
  border: '1px solid rgba(0, 0, 0, 0.08)'
})

const CDialogActions = styled(DialogActions)({
  borderWidth: '1px 0 0',
  borderStyle: 'solid',
  borderColor: '#EBEBEB'
})

const CButton = styled(Button)({
  border: '1px solid rgba(0, 0, 0, 0.08)',
  color: '#424242',
  backgroundColor: '#f5f5f5',
})

const CTextField = styled(TextField)({
  '.MuiInputBase-input': {
    padding: '8px 14px'
  },  
})

const CSelect = styled(Select)({
  // '.MuiInputBase-input': {
  //   padding: '8px 14px'
  // },  
})

const CFormControl = styled(FormControl)({
  // '>.MuiInputLabel-root': {
  //   left: 14,
  //   top: -12
  // }
})

const CSettingButton = styled(Button)({
  minWidth: 20,
  minHeight: 20,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textTransform: 'none',
  fontSize: '0.75rem',
  borderRadius: 4
})

const CSettingPopOver = styled(Popover)({
  '>.MuiPaper-root': {
    boxShadow: '1px 1px 12px rgba(115, 115, 115, 0.2)',
    border: '1px solid #E8E8E8',
    borderRadius: '0.5rem',
    paddingLeft: '0.25rem',
    paddingRight: '0.25rem',

    '>.MuiList-root': {
      paddingBottom: '0.25rem',
      paddingTop: '0.25rem',
      '>.MuiMenuItem-root': {
        paddingLeft: '0.5rem',
        paddingRight: '0.5rem',
        '.MuiListItemText-primary': {
          fontSize: '0.75rem',
          fontWeight: 300,
          lineHeight: 1.2
        }
      }
    }
  }
})

export {
  CButton,
  CDialog,
  CDialogTitle,
  CDialogActions,
  CFormControl,
  CTextField,
  CSelect,
  CSettingButton,
  CSettingPopOver
}